import { OPEN_TALK, CLOSE_TALK, GET_CURRENT_WALK } from '../constants/index';
import { TalkState, TalkActions } from '../types/talkTypes'

const initialState: TalkState = {
  isOpen: false,
  walk: null
}

const talkReducer = (state = initialState, action: TalkActions) => {
  const payload = action.payload
  switch(action.type){

    case OPEN_TALK:
      return {
        ...state,
        isOpen: true,
      }
    
    case GET_CURRENT_WALK:
      return {
        ...state,
        walk: payload
      }

    case CLOSE_TALK:
      return {
        ...state,
        isOpen: false,
      }
    
    default: 
      return state
  }
}

export default talkReducer;